import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal-new-team",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modal-new-team-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-content",
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newTeamApplyShortcut && _ctx.newTeamApplyShortcut(...args)))
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: "modal-new-team-title"
          }, "New Team"),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("span", { "aria-hidden": "true" }, "×")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { for: "modal-new-team-name" }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "modal-new-team-name",
                placeholder: "Team name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTeamName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newTeamName]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { for: "modal-new-team-desc" }, "Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "modal-new-team-desc",
                rows: "3",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTeamDesc) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newTeamDesc]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BtnSubmit, {
            title: "Create Team",
            spinner: "",
            ref: "submitButton",
            submitHandler: _ctx.createTeam
          }, null, 8, ["submitHandler"])
        ])
      ], 32)
    ])
  ]))
}